var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-book-gallery"},[(_vm.containExplicit && _vm.contentIsHidden)?_c('DExplicitOverlay',{attrs:{"button-text":"Show gallery"},on:{"button-click":_vm.showContent}}):_c('DuiGallery',{staticClass:"background-grey",attrs:{"images":_vm.vm.bookImages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }